import { render } from "./TheBlockedUsersList.vue?vue&type=template&id=48d8de76"
import script from "./TheBlockedUsersList.vue?vue&type=script&lang=js"
export * from "./TheBlockedUsersList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__